/**
 * Set the parameters to the link href
 * @param {HTMLElement} link - The link to set the parameters to
 * @param {Object.<string, string>} params - The search parameters to set
 *
 * @returns {void}
 * @example
 * addLinkSearchParams(linkElement, { searchKey: searchValue })
 */
const addLinkSearchParams = (link, params) => {
  const url = new URL(link.href)
  Object.entries(params).forEach(([key, value]) => {
    url.searchParams.append(key, value)
  })
  link.setAttribute("href", url.href)
}

/**
 * Add device id to app links
 * @param {String} deviceId - The device id to add to the app links
 * @returns {void}
 * @example
 * addDeviceIdToAppLinks("123456")
 */
const addDeviceIdToAppLinks = (deviceId) => {
  const appLinks = document.querySelectorAll(".js_app_link")
  appLinks.forEach((appLink) => {
    switch (appLink.dataset.appOs) {
      case "android":
        addLinkSearchParams(appLink, { referrer: `first_client_id=${deviceId}` })
        break
      case "ios":
        addLinkSearchParams(appLink, { first_client_id: deviceId })
        break
      default:
        break
    }
  })
}

// Get device id from google analytics
// @param cb: function
function withGaDeviceId(cb) {
  let gaDeviceId = null
  let count = 0
  const interval = setInterval(() => {
    if (count > 10) {
      clearInterval(interval)
      return
    }
    gaDeviceId = window.gaGlobal?.vid
    if (gaDeviceId) {
      clearInterval(interval)
      cb(gaDeviceId)
    }
    count += 1
  }, 5000)
}

export default () => {
  withGaDeviceId(addDeviceIdToAppLinks)
}
